module.exports = __webpack_public_path__ + "img/WechatIMG6043.977f90e7.jpg";